// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ngbdropdown {
  outline: 1px solid;
  outline: auto -webkit-focus-ring-color;
  outline-color: #b39841;
  border: none;
}
.select-body-container .options-container .option-container .text {
  margin-left: 0;
}
.select-body-container .options-container .option-container.selected {
  color: #ffffff;
  background-color: #7F6C2E;
}
.select-body-container .options-container .heading.selectable:hover {
  background-color: #7F6C2E !important;
}
.select-body-container .options-container .heading.selectable:hover span {
  color: #ffffff;
}
button {
  min-height: 40px;
  background-color: #ffffff;
  border: 1px solid #d4cfbe;
  padding: 8px 11px 8px 11px;
  font-family: Montserrat-Light, sans-serif;
  font-size: 15px;
  position: relative;
  width: 100%;
  text-align: left;
  border-radius: 0;
  white-space: normal;
}
.dropdown-menu .dropdown-item-search:focus,
.dropdown-menu .dropdown-item-search:active {
  border: 1px solid #7F6C2E !important;
  outline: none !important;
  scrollbar-shadow-color: 0 0 !important;
}
.collapse {
  display: block;
  width: 23px;
  height: 23px;
  float: right;
  background-image: url('closed-chev-big.847c1b52d4b4a306.svg');
  min-height: auto;
}
.collapse.active {
  background-image: url('open-chev-big.f05d398ec6e57c90.svg');
}
.collapse:hover {
  cursor: pointer;
}
.clear-input {
  outline: none;
  border: none;
  position: absolute;
  min-height: auto;
  z-index: 5;
  bottom: 5px;
  right: 40px;
  height: 24px;
  width: 24px;
  background-image: url('cross.94f7db39b7176d24.svg');
  background-repeat: no-repeat;
  background-position: center;
  visibility: hidden;
}
.clear-input:hover {
  background-image: url('cross-hover.51d99dd21ec0e20c.svg');
  cursor: pointer;
}
.dropdown-item-search-container {
  width: 100%;
  height: 65px;
  padding: 15px 10px 10px;
}
.dropdown-menu .heading {
  color: #b39841;
}
.dropdown-menu .selectable:focus,
.dropdown-menu .selectable:active,
.dropdown-menu .selectable:hover {
  color: white;
}
.dropdown {
  background-color: #ffffff;
}
.tabableSingleSelect:focus {
  outline: none !important;
  border: 1px solid #b39841 !important;
  box-shadow: 0 0 10px #b39841 !important;
}
.singleselectDropdown {
  display: flex;
}
.clear-input:hover,
.clear-input:active .clear-input:focus {
  outline: 1px solid;
  outline: auto -webkit-focus-ring-color;
  outline-color: #b39841;
  border: none;
}
button.disabled:focus,
button.disabled:active {
  border: none !important;
  outline: none !important;
}
.work-break-all {
  word-break: break-all;
}
.dropdown-menu button {
  border: none;
}
.dropdown-item:hover:not(.disabled),
.dropdown-item:active:not(.disabled),
.dropdown-item:focus:not(.disabled) {
  color: #ffffff;
  background-color: #7F6C2E !important;
  width: 100%;
}
.dropdown-menu {
  padding: 0;
  margin: 0 0 85px 0;
  width: 100%;
  max-height: 500px;
  overflow-y: scroll;
  z-index: 11;
  overscroll-behavior: contain;
}
.dropdown-item-search-container .dropdown-item-search {
  width: 100%;
}
.chev {
  margin: auto 0 auto 4px;
  outline: none;
  border: none;
}
.chev:hover {
  border: none;
}
.clear-input:hover {
  border: none !important;
}
.titleInput {
  color: #444444;
  margin-top: 0;
  display: inline-block;
  font-family: Montserrat-Light, sans-serif;
  font-size: 15px;
  width: 100%;
  float: left;
  white-space: normal;
  border: none;
  outline: none;
  text-shadow: none;
}
.single-select-dropdown ::ng-deep .dropdown-toggle {
  text-align: left;
  border: 1px solid #d4cfbe;
  outline: none;
  box-shadow: none;
  min-height: 40px;
  width: 100%;
  background-color: #ffffff;
  border-radius: 0 !important;
  color: #444444;
  font-size: 15px;
  padding-top: 8px;
}
.single-select-dropdown ::ng-deep .dropdown-toggle.disabled {
  cursor: default !important;
}
.single-select-dropdown .dropdown-toggle-placeholder {
  color: #999999;
  font-size: 15px;
}
.single-select-dropdown ::ng-deep .dropdown-toggle:hover:not(.disabled) {
  cursor: pointer;
}
.single-select-dropdown ::ng-deep .dropdown-toggle:hover:not(.disabled) .clear-input {
  visibility: visible;
}
::ng-deep oir-singleselect.invalid .dropdown-toggle {
  background-color: #ffe5e9 !important;
  border: 1px solid #c30e2e !important;
}
::ng-deep oir-singleselect.invalid .dropdown-toggle .titleInput {
  background-color: #ffe5e9 !important;
  font-family: Montserrat-Light, sans-serif !important;
}
::ng-deep oir-singleselect.invalid .dropdown-toggle .collapse {
  background-color: #ffe5e9 !important;
}
`, "",{"version":3,"sources":["webpack://./node_modules/proceduralsystem-clientcomponents/components/select/select.less","webpack://./node_modules/proceduralsystem-clientcomponents/components/select/singleselect.component.less"],"names":[],"mappings":"AAEA;EACI,kBAAA;EACA,sCAAA;EACA,sBAAA;EACA,YAAA;ACDJ;ADIA;EAIgB,cAAA;ACLhB;ADQY;EACI,cAAA;EACA,yBAAA;ACNhB;ADHA;EAcY,oCAAA;ACRZ;ADNA;EAiBgB,cAAA;ACRhB;ADcA;EACI,gBAAA;EACA,yBAAA;EACA,yBAAA;EACA,0BAAA;EACA,yCAAA;EACA,eAAA;EACA,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;ACZJ;ADeA;;EAEI,oCAAA;EACA,wBAAA;EACA,sCAAA;ACbJ;ADgBA;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,6DAAA;EACA,gBAAA;ACdJ;ADgBI;EACI,2DAAA;ACdR;ADiBI;EACI,eAAA;ACfR;ADmBA;EACI,aAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,mDAAA;EACA,4BAAA;EACA,2BAAA;EACA,kBAAA;ACjBJ;ADmBI;EACI,yDAAA;EACA,eAAA;ACjBR;ADqBA;EACI,WAAA;EACA,YAAA;EACA,uBAAA;ACnBJ;ADsBA;EACI,cAAA;ACpBJ;ADuBA;;;EAGI,YAAA;ACrBJ;ADuBA;EACE,yBAAA;ACrBF;AAnFA;EACI,wBAAA;EACA,oCAAA;EACA,uCAAA;AAqFJ;AAlFA;EACE,aAAA;AAoFF;AAjFA;;EAEI,kBAAA;EACA,sCAAA;EACA,sBAAA;EACA,YAAA;AAmFJ;AAhFA;;EAEI,uBAAA;EACA,wBAAA;AAkFJ;AA/EA;EACI,qBAAA;AAiFJ;AA9EA;EACI,YAAA;AAgFJ;AA7EA;;;EAGI,cAAA;EACA,oCAAA;EACA,WAAA;AA+EJ;AA5EA;EACI,UAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,4BAAA;AA8EJ;AA3EA;EACI,WAAA;AA6EJ;AA1EA;EACI,uBAAA;EACA,aAAA;EACA,YAAA;AA4EJ;AA1EI;EACI,YAAA;AA4ER;AAvEI;EACI,uBAAA;AAyER;AArEA;EACI,cAAA;EACA,aAAA;EACA,qBAAA;EACA,yCAAA;EACA,eAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,iBAAA;AAuEJ;AApEA;EAEQ,gBAAA;EACA,yBAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,yBAAA;EACA,2BAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AAqER;AAjFA;EAgBQ,0BAAA;AAoER;AApFA;EAoBQ,cAAA;EACA,eAAA;AAmER;AA/DQ;EACI,eAAA;AAiEZ;AAlEQ;EAIQ,mBAAA;AAiEhB;AA1DI;EAEQ,oCAAA;EACA,oCAAA;AA2DZ;AA9DI;EAMY,oCAAA;EACA,oDAAA;AA2DhB;AAlEI;EAWY,oCAAA;AA0DhB","sourcesContent":["@import (reference) \"../../styles/variables.less\";\n\nngbdropdown {\n    outline: 1px solid;\n    outline: auto -webkit-focus-ring-color;\n    outline-color: @primary-90;\n    border: none;\n}\n\n.select-body-container {\n    .options-container {\n        .option-container {\n            .text {\n                margin-left: 0;\n            }\n\n            &.selected {\n                color: @white;\n                background-color: @primary-base;\n            }\n        }\n\n        .heading.selectable:hover {\n            background-color: @primary-base !important;\n\n            span {\n                color: @white;\n            }\n        }\n    }\n}\n\nbutton {\n    min-height: 40px;\n    background-color: @white;\n    border: 1px solid @primary-50;\n    padding: 8px 11px 8px 11px;\n    font-family: Montserrat-Light, sans-serif;\n    font-size: 15px;\n    position: relative;\n    width: 100%;\n    text-align: left;\n    border-radius: 0;\n    white-space: normal;\n}\n\n.dropdown-menu .dropdown-item-search:focus,\n.dropdown-menu .dropdown-item-search:active {\n    border: 1px solid @primary-base !important;\n    outline: none !important;\n    scrollbar-shadow-color: 0 0 !important;\n}\n\n.collapse {\n    display: block;\n    width: 23px;\n    height: 23px;\n    float: right;\n    background-image: url(\"../../styles/img/closed-chev-big.svg\");\n    min-height: auto;\n\n    &.active {\n        background-image: url(\"../../styles/img/open-chev-big.svg\");\n    }\n\n    &:hover {\n        cursor: pointer;\n    }\n}\n\n.clear-input {\n    outline: none;\n    border: none;\n    position: absolute;\n    min-height: auto;\n    z-index: 5;\n    bottom: 5px;\n    right: 40px;\n    height: 24px;\n    width: 24px;\n    background-image: url(\"../../styles/img/cross.svg\");\n    background-repeat: no-repeat;\n    background-position: center;\n    visibility: hidden;\n\n    &:hover {\n        background-image: url(\"../../styles/img/cross-hover.svg\");\n        cursor: pointer;\n    }\n}\n\n.dropdown-item-search-container {\n    width: 100%;\n    height: 65px;\n    padding: 15px 10px 10px;\n}\n\n.dropdown-menu .heading {\n    color: @primary-90;\n}\n\n.dropdown-menu .selectable:focus,\n.dropdown-menu .selectable:active,\n.dropdown-menu .selectable:hover {\n    color: white;\n}\n.dropdown {\n  background-color: @white;\n}\n","@import (reference) \"../../styles/variables.less\";\n@import \"./select\";\n\n.tabableSingleSelect:focus {\n    outline: none !important;\n    border: 1px solid @primary-90 !important;\n    box-shadow: 0 0 10px @primary-90 !important;\n}\n\n.singleselectDropdown {\n  display: flex;\n}\n\n.clear-input:hover,\n.clear-input:active .clear-input:focus {\n    outline: 1px solid;\n    outline: auto -webkit-focus-ring-color;\n    outline-color: @primary-90;\n    border: none;\n}\n\nbutton.disabled:focus,\nbutton.disabled:active {\n    border: none !important;\n    outline: none !important;\n}\n\n.work-break-all {\n    word-break: break-all;\n}\n\n.dropdown-menu button {\n    border: none;\n}\n\n.dropdown-item:hover:not(.disabled),\n.dropdown-item:active:not(.disabled),\n.dropdown-item:focus:not(.disabled) {\n    color: @white;\n    background-color: @primary-base !important;\n    width: 100%;\n}\n\n.dropdown-menu {\n    padding: 0;\n    margin: 0 0 85px 0;\n    width: 100%;\n    max-height: 500px;\n    overflow-y: scroll;\n    z-index: 11;\n    overscroll-behavior: contain;\n}\n\n.dropdown-item-search-container .dropdown-item-search {\n    width: 100%;\n}\n\n.chev {\n    margin: auto 0 auto 4px;\n    outline: none;\n    border: none;\n\n    &:hover {\n        border: none;\n    }\n}\n\n.clear-input {\n    &:hover {\n        border: none !important;\n    }\n}\n\n.titleInput {\n    color: @secondary-90;\n    margin-top: 0;\n    display: inline-block;\n    font-family: Montserrat-Light, sans-serif;\n    font-size: 15px;\n    width: 100%;\n    float: left;\n    white-space: normal;\n    border: none;\n    outline: none;\n    text-shadow: none;\n}\n\n.single-select-dropdown {\n    ::ng-deep .dropdown-toggle {\n        text-align: left;\n        border: 1px solid @primary-50;\n        outline: none;\n        box-shadow: none;\n        min-height: 40px;\n        width: 100%;\n        background-color: @white;\n        border-radius: 0 !important;\n        color: @secondary-90;\n        font-size: 15px;\n        padding-top: 8px;\n    }\n\n    ::ng-deep .dropdown-toggle.disabled {\n        cursor: default !important;\n    }\n\n    .dropdown-toggle-placeholder {\n        color: @secondary-60;\n        font-size: 15px;\n    }\n\n    ::ng-deep .dropdown-toggle {\n        &:hover:not(.disabled) {\n            cursor: pointer;\n\n            .clear-input {\n                visibility: visible;\n            }\n        }\n    }\n}\n\n::ng-deep oir-singleselect {\n    &.invalid {\n        .dropdown-toggle {\n            background-color: @invalid-fill !important;\n            border: 1px solid @invalid-outline !important;\n\n            .titleInput {\n                background-color: @invalid-fill !important;\n                font-family: Montserrat-Light, sans-serif !important;\n            }\n\n            .collapse {\n                background-color: @invalid-fill !important;\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
